/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Kind_Local_DescInputs */



/**
* | output |
* | --- |
* | "One afternoon or evening. Players turn up, sign up at the door, and play a few rounds and a final." |
*
* @param {Tournament_Wiz_Kind_Local_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_kind_local_desc = /** @type {((inputs?: Tournament_Wiz_Kind_Local_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Kind_Local_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Un après-midi ou une soirée. Les joueurs arrivent, s'inscrivent sur place et jouent quelques rondes et une finale.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Una tarde o una noche. Los jugadores llegan, se inscriben en la puerta y juegan unas rondas y una final.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Uma tarde ou uma noite. Os jogadores chegam, se inscrevem na entrada e jogam algumas rodadas e uma final.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Un pomeriggio o una sera. I giocatori arrivano, si iscrivono all'ingresso e giocano qualche round e una finale.")
	return /** @type {LocalizedString} */ ("One afternoon or evening. Players turn up, sign up at the door, and play a few rounds and a final.")
});